<template>
  <router-view name="order" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Order",
};
</script>
